import { FormFieldsGeneratorService } from './../form-helpers/form-fields-generator.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormStateChange, FormStateChangeService, StateInputFields } from '../form-state/form-state-change.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { FormFieldsMasks } from '../field-mask/form-fields-masks';
import { CustomerDetailsModel } from '../../models/customer-details.model';
import { CommonInfoService } from '../../cart-process/common-info.service';
import SlotService from '../../cart-process/slot.service';
import { FormGroup } from '@angular/forms';
import { MsisdnFormat } from '../../utils/pipes/msisdnFormat';
import { IdTypeEnum } from '../../models/cartDetails/idType.enum';

@Component({
  selector: 'user-data-details-component',
  templateUrl: './user-data-details.component.html'
})
export class UserDataDetailsComponent implements OnInit {

  public userDetailsForm: any = {
    'email': {value: '', showInput: false},
    'phone': {value: '', showInput: false},
  };
  public activeForm: FormGroup;
  public userDetails: CustomerDetailsModel;
  public isB2BOffer = false;
  public showEmailAdditionalInfo = false;
  public formFields: any;
  public formGroups: { [s: string]: FormGroup } = {};
  public idTypeEnum = IdTypeEnum;

  private msisdnFormat: MsisdnFormat = new MsisdnFormat();

  constructor(
    public validationMasks: FormFieldsMasks,
    private element: ElementRef,
    private formStateChangeService: FormStateChangeService,
    private notificationProvider: NotificationProviderService,
    private commonInfo: CommonInfoService,
    private slotService: SlotService,
    private formsGenerator: FormFieldsGeneratorService
  ) {
    if (this.commonInfo.isRetentionOffer && !this.slotService.hasAtLeastOneDeviceInCart()) {
      this.showEmailAdditionalInfo = true;
    }
  }

  public onFieldEdit(fieldId: string): void {
    this.userDetailsForm[fieldId].showInput = true;

    const element = this.element.nativeElement.querySelector('#' + fieldId);

    setTimeout(() => {
      element.focus();
    });
  }

  public onFieldAccept(formId: string): void {
    if (this.activeForm.controls[formId].valid) {
      const fieldId = formId === 'customerEmail' ? 'email' : 'phone';
      this.userDetailsForm[fieldId].showInput = false;
    }
  }

  private fillCustomerData(consumerDetails: CustomerDetailsModel): void {
    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CONTRACT_ADDRESS_FORM_VALIDATE,
        true
      )
    );

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CONTRACT_ADDRESS_FORM_VALUES,
        consumerDetails.contractAddress
      )
    );

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CONTRACT_ADDRESS_FORM_VALUES_STRING,
        consumerDetails.getJoinContractAddressForView()
      )
    );

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CORRESPONDENCE_OTHER_ADDRESS_VALUES,
        consumerDetails.correspondenceAddress
      )
    );

    this.formStateChangeService.setField(
      new FormStateChange(
        StateInputFields.CORRESPONDENCE_OTHER_ADDRESS_STRING,
        consumerDetails.getJoinCorrespondenceAddressForView()
      )
    );

    const emailValue = consumerDetails.email;
    const phoneValue = this.msisdnFormat.transform(consumerDetails.phone);

    this.userDetailsForm['email'].value = emailValue;
    this.userDetailsForm['phone'].value = phoneValue;
  }

  private prepareFormControls(): void {
    this.formsGenerator.createCustomerDetailsForm(this.userDetailsForm['email'].value, this.userDetailsForm['phone'].value);
    this.activeForm = this.formsGenerator.getActiveForm();
  }

  ngOnInit(): void {
    this.notificationProvider.subscribe(NotificationProviderTypeEnum.CUSTOMER_DETAILS, (customerData: CustomerDetailsModel) => {
      if (!customerData) {
        return;
      }

      this.userDetails = customerData;
      this.fillCustomerData(customerData);
    });

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (!commonInfo) {
        return;
      }

      this.isB2BOffer = !commonInfo.b2c;
    });

    this.prepareFormControls();
  }
}
